import { render } from "./FoamOnlyNotice.vue?vue&type=template&id=3daa08de"
import script from "./FoamOnlyNotice.vue?vue&type=script&lang=js"
export * from "./FoamOnlyNotice.vue?vue&type=script&lang=js"
script.render = render

export default script